import React from "react";
import { LOGO_ONLY, TOPBAR_HEIGHT, TOPHEADER_HEIGHT } from "../constants";
import { history } from "../_helpers/history";
// import LogoLight from "../media/imgs/Q_logo_b.png";
// import LogoDark from "../media/imgs/Q_logo_w.png";
import LOGO_SQUARE from "../media/imgs/0_logo_square.png";

export default function Logo({ theme = "dark", square = false }) {
    return (
        <div
            style={{
                width: "auto",
                height: TOPBAR_HEIGHT,
                maxHeight: TOPBAR_HEIGHT,
                // background: "#f0f2f5",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                // justifyContent: "center",
                // marginBottom: "15px",
                borderBottom: "1px solid var(--border-color)",
                cursor: "pointer",
            }}
            onClick={() => {
                history.push("/home");
            }}
        >
            <img
                alt="Logo"
                // src={theme === "dark" ? LogoDark : LogoLight}
                src={square ? LOGO_SQUARE : LOGO_ONLY}
                style={{
                    width: "auto",
                    height: "60%",
                }}
            />
        </div>
    );
}
